export enum FEATURE_FLAG {
  ANALYTICS_PAGE = "analytics-page",
  RUN_PLANNING = "run-planning",
  TACTICAL_SIMULATION = "tactical-simulation",
  CAPACITY_UNITS_PAGE = "capacity-units",
}
